module.exports = __webpack_public_path__ + "static/media/html5+css3-mobile.43ec3ee6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/html5+css3-mobile.png
// module id = 66
// module chunks = 0